module.exports = __webpack_public_path__ + "static/media/defaultImage.22fffceb.png";